__turbopack_context__.v({
  "boton_especial": "header-module___9ea4W__boton_especial",
  "burger_button": "header-module___9ea4W__burger_button",
  "cta": "header-module___9ea4W__cta",
  "header": "header-module___9ea4W__header",
  "header__logo": "header-module___9ea4W__header__logo",
  "menuOverlay": "header-module___9ea4W__menuOverlay",
  "mover": "header-module___9ea4W__mover",
  "nav__nav_link": "header-module___9ea4W__nav__nav_link",
  "nav__nav_link__button": "header-module___9ea4W__nav__nav_link__button",
});
